import React, { PureComponent } from 'react';

import { Helmet } from 'react-helmet';
import { injectIntl, intlShape } from 'react-intl';

import ErrorsPage from 'components/Errors';
import globalMessages from 'translations/messages/global-messages';

class Page404 extends PureComponent {
  render() {
    const { intl } = this.props;

    return (
      <>
        <Helmet>
          <title>
            {intl.formatMessage(globalMessages.not_page_looking_for)} |{' '}
            {intl.formatMessage(globalMessages.finalcad)}
          </title>
        </Helmet>
        <ErrorsPage
          codeTitle="404"
          description={intl.formatMessage(globalMessages.not_page_looking_for)}
        />
      </>
    );
  }
}
Page404.propTypes = {
  intl: intlShape.isRequired,
};

Page404.defaultProps = {};

export default injectIntl(Page404);
